import { jsx as _jsx } from "react/jsx-runtime";
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { shouldShowGroupSeparator } from '#pplx/frontend/composer-sdk/internal/typeahead/shouldShowGroupSeparator.js';
import { getRowDomId } from '#pplx/frontend/composer-sdk/internal/typeahead/typeaheadMenuData.js';
import { TypeaheadMenuGroup } from '#pplx/frontend/composer-sdk/internal/typeahead/TypeaheadMenuGroup.js';
import { TypeaheadOptionRow } from '#pplx/frontend/composer-sdk/internal/typeahead/TypeaheadOptionRow.js';
import React from 'react';
export function TypeaheadMenuEntry({ entry, groupTitleVariant, ...itemProps }) {
    switch (entry.type) {
        case 'item': {
            const { row, index } = entry.item;
            return (_jsx(TypeaheadOptionRow, { id: getRowDomId(itemProps.idBase, row), row: row, highlighted: index === itemProps.selectedIndex, size: itemProps.rowSize, highlightStyle: itemProps.highlightStyle, onHighlight: () => itemProps.onHighlight(index), onSelect: () => itemProps.onSelect(index), listboxRef: itemProps.listboxRef }));
        }
        case 'group': {
            const title = entry.rows[0].row.groupTitle;
            const heading = title === undefined || groupTitleVariant === undefined
                ? undefined
                : { title, variant: groupTitleVariant };
            return (_jsx(TypeaheadMenuGroup, { rows: entry.rows, showSeparator: shouldShowGroupSeparator({
                    hasPreviousGroup: entry.showSeparator,
                    hasHeading: heading !== undefined,
                    variant: groupTitleVariant,
                }), heading: heading, ...itemProps }));
        }
        default:
            return assertUnreachableValue(entry);
    }
}
//# sourceMappingURL=TypeaheadMenuEntry.js.map